import { Role } from "../../Types/Role/RoleModel";
import { TableColumn } from "react-data-table-component";
import RoleModal from "../../Components/UiKits/Modal/UserModal/RoleModal";

export const RoleTableColumn: TableColumn<Role>[] = [
  {
    name: "ICON",
    selector: (row) => row.icon,
    sortable: false,
    width: "100px",
    center: false,
    cell: (row) => (
      <div
        className={`d-flex align-items-center justify-content-center rounded-3 bg-light-${row.color} text-${row.color}`}
        style={{
          width: "35px",
          height: "35px",
        }}
      >
        <i className={`fa ${row.icon} fs-6`}></i>
      </div>
    ),
  },
  {
    name: "ROLE",
    selector: (row) => row.name,
    sortable: true,
    width: "300px",
    center: false,
  },
  {
    name: "DESCRIPTION",
    selector: (row) => row.description,
    sortable: true,
    center: false,
    cell: (row) => (
      <div
        style={{
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflowWrap: "break-word",
        }}
      >
        {row.description}
      </div>
    ),
  },
  // {
  //   name: "ACTION",
  //   sortable: true,
  //   center: false,
  //   cell: (row) => {
  //     if (!row) return null;
  //     return <RoleModal id={row.id} role={row.name || ""} />;
  //   },
  //   width: "200px",
  // },
];
